export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer id="footer" className="bg-background-950">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-lg text-background-50"></i>
              </span>
              <span className="text-lg font-bold text-background-50 font-heading">蓝莓影院</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              蓝莓影院提供海量电影大全，涵盖最新上映、高清经典影片，免费在线观看，不缓冲流畅播放，每日更新，影迷观影好选择。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '平台优势', href: '#features' },
                { label: '精彩视频', href: '#media' },
                { label: '影迷评价', href: '#comments' },
                { label: '常见问答', href: '#faq' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">热门专题</h4>
            <div className="flex flex-col gap-2.5">
              {['暑期档', '科幻巨制', '华语新片', '经典重温', '动画合集'].map((item) => (
                <a
                  key={item}
                  href="#index"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  {item}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">合作伙伴</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              蓝莓影院与多家优质内容提供商保持合作关系，持续为影迷带来丰富的观影选择。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#contact" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-background-700 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-mail-line text-background-200 text-sm"></i>
              </a>
              <a href="#contact" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-background-700 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-wechat-line text-background-200 text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800/60 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {year} 蓝莓影院 · 致力于为影迷提供免费高清流畅的观影体验
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span>电影大全</span>
            <span>免费在线</span>
            <span>流畅播放</span>
            <span>每日更新</span>
          </div>
        </div>
      </div>
    </footer>
  );
}